//Admin Map
export const SET_ALL_MEMBERS = "SET_ALL_MEMBERS";

//RESET_STATE
export const RESET_STATE = "RESET_STATE";
export const CLEAR_ACCOUNT_DATA = "CLEAR_ACCOUNT_DATA";

//Login
export const SET_LOGIN_CREDENTIALS = "SET_LOGIN_CREDENTIALS";
